import React from "react";

/**
 * MockScope — scoped opt-in to the mock data layer.
 *
 * Real auth and real API calls remain the default everywhere. A component
 * tree wrapped in <MockScope> routes useQuery/useMutation calls through the
 * mock registry when an entry matches; unmocked methods fall through to the
 * real backend.
 *
 * Use the `mockScopedRoutes(flag, route)` helper for whole-page previews,
 * or wrap a subtree directly for finer-grained scoping (e.g. one tab).
 */
const MockScopeContext = React.createContext<boolean>(false);

export const MockScope: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <MockScopeContext.Provider value={true}>{children}</MockScopeContext.Provider>
);

export const useIsInMockScope = (): boolean =>
  React.useContext(MockScopeContext);
